if (!customElements.get('image-zoom-modal')) {
  class ZoomModal extends HTMLElement {
    constructor() {
      super();
      this.selector = this.dataset.imageWrapperSelector;
      this.isOpen = false;
    }

    connectedCallback() {
      if (this.closest('main')) document.body.insertBefore(this, document.body.firstChild);

      window.addEventListener('click', (e) => {
        const clickedElement = e.target.closest(this.selector) || e.target.closest('[data-zoom-action]');
        if(!clickedElement) return;

        if(!this.isOpen && e.target.closest(this.selector)) {
          this.triggerImage = e.target.closest('img');
          this.images = [...e.target.closest(this.selector).querySelectorAll('img')];
          this.open();
          this.updateModelSizingInfo();
          return;
        }

        const {
          zoomAction: action,
        } = clickedElement.dataset;

        switch (action) {
          case 'close':
          this.close();
          break;
          default: break;
        }

      })
    }

    close() {
      this.classList.remove('fixed');
      this.style.display = null;

      this.isOpen = false;
      this.innerHTML = '';
      document.body.classList.remove('overlay');

      this.style.opacity = null;
    }

    open() {
      const startingIndex = this.images.findIndex(x => x === this.triggerImage);
      this.isOpen = true;
      document.body.classList.add('overlay');
      this.innerHTML = `
      <div class="relative w-full">
        <button data-zoom-action="close" type="button" aria-label="close modal" class="absolute bg-primaryLight block top-0 right-0 p-8 flex items-center transition duration-200 hover:text-accent1 z-10 animation-spin">
          <div class="w-3 h-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 12 12">
              <path d="M10.795 0 6 4.795 1.2 0 0 1.2 4.795 6 0 10.795 1.2 12 6 7.205 10.795 12 12 10.795 7.205 6 12 1.2z"/>
            </svg>
          </div>
        </button>
        <swiper-image-gallery data-starting-index="${startingIndex || 0}" class="flex">
          <div class="w-1/4 p-10 h-screen overflow-hidden hidden md:block">
            <div data-thumbs class="h-4/5">
              <div class="swiper-wrapper flex flex-col flex-wrap items-center justify-start gap-1.5 w-[max-content!important] text-transparent">
                ${this.images.map((img) => `
                  <div class="swiper-slide w-[72px!important]  h-[72px!important] cursor-pointer">
                    <img class="transition duration-200 border border-current block w-full h-full object-center object-cover" loading="lazy" height="78" width="72" alt="${img.alt}" src="${img.src.replaceAll('width=1242', 'width=200').replaceAll('height=1674', 'height=200')}" />
                  </div>
                `).join('')}
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 h-screen flex justify-center items-center">
            <div data-gallery class="h-screen bg-image-bg aspect-[3/4] overflow-hidden">
              <div class="swiper-wrapper cursor-zoom-in">
                ${this.images.map((img) => `
                  <div class="swiper-slide">
                    <div data-zoom-container class="swiper-zoom-container">
                      <img class="block w-full h-full object-center object-contain" loading="lazy" height="2400" width="2400" alt="${img.alt}" src="${img.src.replace('width=1200', 'width=2400')}" />
                    </div>
                  </div>
                `).join('')}
              </div>
            </div>
          </div>
          <div class="flex flex-col items-center w-max gap-1 left-1/2 transform -translate-x-1/2 absolute bottom-0 z-20 bg-primaryLight">
            <p class="flex items-center p-5 text-xs" data-img-model-sizing></p>

            ${this.images.length > 1 ? `
              <div class="flex items-center w-max gap-8 px-5 py-8">
                <button class="disabled:opacity-20 hover:enabled:text-accent1" aria-label="previous slide" data-prev>
                  <span class="block w-4 h-3 transform rotate-180">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                      <defs>
                        <clipPath id="dpuo5a2tba">
                        <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                        </clipPath>
                      </defs>
                      <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                    </svg>
                  </span>
                </button>
                <div data-pagination></div>
                <button class="disabled:opacity-20 hover:enabled:text-accent1" aria-label="next slide" data-next>
                  <span class="block w-4 h-3">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                      <defs>
                        <clipPath id="dpuo5a2tba">
                          <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                        </clipPath>
                      </defs>
                      <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                    </svg>
                  </span>
                </button>
              </div>
            ` : ''}
          </div>
        </swiper-image-gallery>
      </div>
      `;
      this.style.display = 'block';
      this.classList.add('fixed');
      setTimeout(() => { this.style.opacity = 1 }, 10);
    }

    updateModelSizingInfo() {
      const currentModelSizingInfo = document.querySelector('[data-model-sizing]');
      const imgSizingInfo = this.querySelector('[data-img-model-sizing]');

      if(currentModelSizingInfo.innerHTML) {
        imgSizingInfo.innerHTML = currentModelSizingInfo.innerHTML;
      } else {
        imgSizingInfo.style.display = 'none';
      }
    }
  }

  customElements.define('image-zoom-modal', ZoomModal);
}